import React, { FC } from 'react';
import Typography from '@components/typography';
import { useDeviceDetect } from '@hooks/usedevicedetect';
import classnames from 'classnames';

import '@styles/tag.scss';
import { Dictionary } from 'interface';

export const TagType: Dictionary<string> = {
  Delivery: 'delivery',
  'Special Offer': 'special-offer',
  Carwow: 'review',
};

interface TagProps {
  classNames?: string;
  type: string;
  children: string | JSX.Element;
}

const Tag: FC<TagProps> = ({ type, children, classNames }) => {
  const { isMobile } = useDeviceDetect();

  const typeValue = TagType[type];
  const typeOfChild = typeof children;

  const renderTag = () => {
    return (
      <div
        data-cy={`tag-${typeValue}`}
        data-testid={`tag-${typeValue}`}
        className={classnames(classNames, `tag__${typeValue}`)}
      >
        {typeOfChild === 'string' ? (
          <Typography
            variant="caption"
            size={isMobile ? 'sm' : 'rg'}
            weight={isMobile ? 'semi-bold' : 'bold'}
            colour="alternative"
          >
            {children}
          </Typography>
        ) : (
          children
        )}
      </div>
    );
  };

  return <>{renderTag()}</>;
};

export default Tag;
